import findResult, { assignIfExists, removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { findAllCatalogues } from './state';
import actions from '../../constants';

const destroyDatasetCatalogue = withDraft((draft, { items }) => {
  findAllCatalogues(draft, { items }).forEach((category) => {
    items.forEach(({ code }) => {
      const item = findResult(draft.catalogues, category, code);
      if (item) {
        draft.catalogues[category].results = removeItemByCode(draft.catalogues[category].results, item);
      }
    });
  });
});

const updateDatasetCatalogueSuccess = withDraft((draft, { code, result }) => {
  findAllCatalogues(draft, { items: [{ code }] }).forEach((category) => {
    const item = findResult(draft.catalogues, category, code);
    assignIfExists(item, { catalogue: result.catalogue });
  });
});

export default {
  [actions.DESTROY_DATASET]: destroyDatasetCatalogue,
  [actions.UPDATE_DATASET_CATALOGUE_SUCCESS]: updateDatasetCatalogueSuccess,
  [actions.UPDATE_DATASET_SUCCESS]: updateDatasetCatalogueSuccess,
};
